import { MixpanelEventSource, MixpanelSourceProvider } from '@talos/kyoko';
import { memo, useCallback } from 'react';
import { defaultBalancesTabs } from '../../../Blotters/BalancesV2/defaults';
import { BALANCES_V2_BLOTTER_PREFIX } from '../../../Blotters/BalancesV2/tokens';
import type { BalancesV2TabProps } from '../../../Blotters/BalancesV2/types';
import { MobileFilteredBalances } from './Balances/MobileFilteredBalances';
import {
  MobileBlotterPanel,
  type MobileBlotterPanelProps,
  type MobileBlotterPanelRenderTabArgs,
} from './MobileBlotterPanel';

export const MobileBalancesBlotter = memo(function MobileBalancesBlotter(
  props: Omit<MobileBlotterPanelProps<BalancesV2TabProps>, 'defaultTabs' | 'renderTab'>
) {
  const renderTab = useCallback(
    ({ tab, tabId, updateTab }: MobileBlotterPanelRenderTabArgs<BalancesV2TabProps>) => (
      <MobileFilteredBalances
        key={tabId}
        blotterID={`${BALANCES_V2_BLOTTER_PREFIX}/${tabId}`}
        tab={tab as BalancesV2TabProps}
        onUpdateTab={updatedTab => updateTab(updatedTab)}
      />
    ),
    []
  );

  return (
    <MixpanelSourceProvider value={MixpanelEventSource.BalancesBlotter}>
      <MobileBlotterPanel<BalancesV2TabProps> {...props} defaultTabs={defaultBalancesTabs} renderTab={renderTab} />
    </MixpanelSourceProvider>
  );
});
